
import { Component, OnInit, Input, OnDestroy, SimpleChanges, OnChanges, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';

import { SharedService } from '@services/shared.service';

import { IQuantifiable } from '@models/Interfaces';
import { EventType } from '@shared/models/Enums';


@Component({
    selector: 'app-market-ticket-quantity',
    templateUrl: './market-ticket-quantity.component.html',
    styleUrls: ['./market-ticket-quantity.component.scss']
})
export class MarketTicketQuantityComponent implements OnInit, OnChanges, OnDestroy {

    @Input() model: IQuantifiable;
    @Input() availableQuantity = 0;
    @Input() eventIsGeneric: boolean = false;
    @Input() availableQuantityByEvent = 0;
    @Input() quantityOfPlaces: number = 1;
    quantitySelectedAllTickets: number = 0;
    @Input() eventType: EventType;
    @Input() ticketStock: number = 0;
    @Input() eventStock: number = 0;
    @Input() purchaseLimit: number = 0;

    @Output() change: EventEmitter<IQuantifiable> = new EventEmitter<IQuantifiable>();

    allSelected: number = 0;

    singleTicketSelected: number = 0;

    isError = false;

    productQuantity = 0;

    validCloseAlert = true;
    validShowAlert = false;

    private loadProductWatchedSubscription: Subscription = null;
    private changeVariantOptionSubscription: Subscription = null;
    private purchaseModalSubscription: Subscription = null;
    private behaviorQuantitySelectedTicketsSubscription: Subscription = null;

    constructor(public sharedService: SharedService) { }

    ngOnInit() {
        
        this.productQuantity = this.model ? this.model.quantitySelected : 1;

        this.purchaseModalSubscription = this.sharedService.showTicketPurchaseModal.subscribe(x => {

            this.productQuantity = this.model ? this.model.quantitySelected : 1;
        });

        this.behaviorQuantitySelectedTicketsSubscription = this.sharedService.getChangeBehaviorQuantitySelectedTickets().subscribe((value: number) => {
            this.quantitySelectedAllTickets = value;

            this.allSelected = this.sharedService.getBehaviorQuantitySelectedTickets();
        });

        // se cierra el modal se limpia la cantidad
        this.loadProductWatchedSubscription = this.sharedService.productWatched.subscribe(() => {

            this.productQuantity = 1;
        });
    }

    ngOnChanges(changes: SimpleChanges) {

        for (const propName in changes) {
            if (propName === 'model') {
                const change = changes[propName];
                if (change.isFirstChange() && (change.previousValue !== change.currentValue)) {

                    this.productQuantity = this.model ? this.model.quantitySelected : 1;
                }
            }
        }
    }

    ngOnDestroy() {

        if (this.loadProductWatchedSubscription) {
            this.loadProductWatchedSubscription.unsubscribe();
            this.loadProductWatchedSubscription = null;
        }
        if (this.changeVariantOptionSubscription) {
            this.changeVariantOptionSubscription.unsubscribe();
            this.changeVariantOptionSubscription = null;
        }
        if (this.purchaseModalSubscription) {
            this.purchaseModalSubscription.unsubscribe();
            this.purchaseModalSubscription = null;
        }

        if (this.behaviorQuantitySelectedTicketsSubscription) { this.behaviorQuantitySelectedTicketsSubscription.unsubscribe(); }
    }

    showError(option){

        if(option == 1){

            if(this.purchaseLimit > 0 && this.singleTicketSelected >= this.purchaseLimit) return true;

        }else{

            //same validations with the same disabled conditions
            if(this.isError) return true;
            //anti revendedores
            /* else if(this.purchaseLimit > 0 && this.singleTicketSelected >= this.purchaseLimit) return true; */
            //cashless validations
            else if((this.eventType != 1 && this.eventType != 2) && 
            (this.productQuantity * this.quantityOfPlaces >= this.availableQuantity && this.ticketStock > 0)) return true;
            
            //event with stock limit 
            else if ((this.eventType == 1 || this.eventType == 2) && this.eventStock > 0 &&
            ((this.allSelected * this.quantityOfPlaces  >= this.availableQuantity || this.allSelected * this.quantityOfPlaces  >= this.availableQuantityByEvent 
                || this.quantityOfPlaces > this.availableQuantity || this.quantityOfPlaces > this.availableQuantityByEvent) 
                && this.ticketStock > 0)) return true;
            
                //event without stock limit 
                else if((this.eventType == 1 || this.eventType == 2) && this.eventStock <= 0 &&
            ((this.productQuantity * this.quantityOfPlaces >= this.availableQuantity || this.quantityOfPlaces > this.availableQuantity)
                && this.ticketStock > 0)) return true;

                else return false;
        } 
    }

    changeQuantity(isAdd: boolean) {

        this.isError = false;
        
        // Cantidad seleccionada por ticket
        let quantitySelected = this.model.quantitySelected; 
        // Cantidad seleccionada de todos los tickets
        this.quantitySelectedAllTickets = this.sharedService.getBehaviorQuantitySelectedTickets();

        // valida si hay que sumar o restar la cantidad
        if (isAdd) {

            quantitySelected = quantitySelected + 1;
            this.quantitySelectedAllTickets = this.quantitySelectedAllTickets + (1  * this.quantityOfPlaces);
        } else {

            quantitySelected = quantitySelected - 1;
            this.quantitySelectedAllTickets = this.quantitySelectedAllTickets - (1 * this.quantityOfPlaces);
            // Update Selected All Tickets 
            this.sharedService.setBehaviorQuantitySelectedTickets(this.quantitySelectedAllTickets);
        }

        this.singleTicketSelected = quantitySelected;

        //is Cashless or pass
        if(this.eventType == EventType.CashlessWithExpirationDate || this.eventType == EventType.CashlessWithOutExpirationDate
            || this.eventType == EventType.PassWithExpirationDate || this.eventType == EventType.PassWithOutExpirationDate){

            // validar que no exceda el limite disponibles
            if (quantitySelected >= 0 && (quantitySelected * this.quantityOfPlaces <= this.availableQuantity || this.ticketStock == 0)) {

                this.model.quantitySelected = Number(quantitySelected);
                this.productQuantity = quantitySelected;
                // Update Selected All Tickets 
                this.sharedService.setBehaviorQuantitySelectedTickets(this.quantitySelectedAllTickets);

                this.change.emit(this.model);

            } else {
                
                this.isError = true;
                quantitySelected = this.model.quantitySelected;
            }

        }else{
            //events

            // Tiene limite de compras ya que valida stock
            if (!this.eventIsGeneric) {
                
                // Valida si debe limitar por cantidad de ticket
                if (!this.model.isGeneric) {

                    // Valida por cantidad maxima del evento 
                    let allTicketSelected = this.sharedService.getBehaviorQuantitySelectedTickets();

                    //is event or pass

                        // Escenario 1 : Evento con limite de stock y limite por ticket
                        // Ej: Evento limite de 20 stock y limite por ticket de 10

                        // valid que la compra no exceda los limites ni por ticket ni por evento
                        if (quantitySelected >= 0 && (quantitySelected * this.quantityOfPlaces) <= this.availableQuantity && 
                            allTicketSelected < this.availableQuantityByEvent && 
                            this.quantitySelectedAllTickets <= this.availableQuantityByEvent) {

                            this.model.quantitySelected = Number(quantitySelected);
                            this.productQuantity = quantitySelected;
                            // Update Selected All Tickets 
                            this.sharedService.setBehaviorQuantitySelectedTickets(this.quantitySelectedAllTickets);

                            this.change.emit(this.model);

                        } else {

                            this.isError = true;
                            quantitySelected = this.model.quantitySelected;
                            /*
                            // TODO: Solucionar como se ve que no descuadre lo demás
                            if (isAdd) {
                                this.validShowAlert = true;
                                this.validCloseAlert = false;

                                setTimeout(() => this.closeAlert(), 4000);
                            } else {
                                this.closeAlert();
                            }
                            */
                        } 
                }
                else {

                    // Escenario 2 : Evento con limite de stock y SIN limite por ticket
                    // Ej: Evento limite de 20 stock y sin limite por ticket pero siempre respeta los 20 del evento
                    
                    // Valida por cantidad maxima del evento 
                    let allTicketSelected = this.sharedService.getBehaviorQuantitySelectedTickets();

                    if (allTicketSelected >= 0 && allTicketSelected < this.availableQuantity &&
                        this.quantitySelectedAllTickets <= this.availableQuantity) {

                        this.model.quantitySelected = Number(quantitySelected);
                        this.productQuantity = quantitySelected;

                        // Update Selected All Tickets 
                        this.sharedService.setBehaviorQuantitySelectedTickets(this.quantitySelectedAllTickets);

                        this.change.emit(this.model);
                    } else {

                        this.isError = true;
                        quantitySelected = this.model.quantitySelected;

                        /*
                        // TODO: Solucionar como se ve que no descuadre lo demás
                        if (isAdd) {
                            this.validShowAlert = true;
                            this.validCloseAlert = false;

                            setTimeout(() => this.closeAlert(), 4000);
                        } else {
                            this.closeAlert();
                        }
                        */
                    }

                }
            }
            else {

                // NO tiene limite de compras ya que NO valida stock general 
                if (this.model.isGeneric) {

                    // Escenario 3 : Evento SIN limite de stock y SIN limite por ticket
                    // Ej: Se puede comprar la cantidad que se desea sin limites

                    // No se valida por que el ticket es generico y se puede comprar cualquier cantidad
                    this.model.quantitySelected = Number(quantitySelected);
                    this.productQuantity = quantitySelected;
                    this.change.emit(this.model);
                }
                else {

                    // Escenario 4 : Evento SIN limite de stock y CON limite por ticket
                    // Ej: Se puede comprar la cantidad que se desea sin superar el limite por ticket
                    
                    // valid que la compra no exceda los limites
                    if (quantitySelected >= 0 && (quantitySelected * this.quantityOfPlaces) <= this.availableQuantity) {

                        this.model.quantitySelected = Number(quantitySelected);
                        this.productQuantity = quantitySelected;

                        this.change.emit(this.model);
                    } else {

                        this.isError = true;
                        quantitySelected = this.model.quantitySelected;
                        /*
                        // TODO: Solucionar como se ve que no descuadre lo demás
                        if (isAdd) {
                            this.validShowAlert = true;
                            this.validCloseAlert = false;

                            setTimeout(() => this.closeAlert(), 4000);
                        } else {
                            this.closeAlert();
                        }
                        */
                    }
                }
            }
        } 
        this.allSelected = this.sharedService.getBehaviorQuantitySelectedTickets(); 

    }

    closeAlert() {

        this.validShowAlert = false;
        this.validCloseAlert = true;
    }
}
